import { render, staticRenderFns } from "./EditExerciseWordStress.vue?vue&type=template&id=8c8dcbde&"
import script from "./EditExerciseWordStress.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseWordStress.vue?vue&type=script&lang=ts&"
import style0 from "./EditExerciseWordStress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports